import PropTypes from 'prop-types';
import { LOCALES, PLATFORMS } from './constants';

export const ProductSubcategoryPropType = PropTypes.shape({
  url: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  product_count: PropTypes.number,
  parent_id: PropTypes.string,
  level: PropTypes.number,
});

export const ProductSubcategoriesPropType = PropTypes.arrayOf(
  ProductSubcategoryPropType,
);

export const ProductCategoryPropType = PropTypes.shape({
  url: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  children: ProductSubcategoriesPropType,
  parent_id: PropTypes.string,
  level: PropTypes.number,
});

export const ProductCategoriesPropType = PropTypes.arrayOf(
  ProductCategoryPropType,
);

export const ProductFamilyPropType = PropTypes.shape({
  url: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  children: ProductCategoriesPropType,
  parent_id: PropTypes.string,
  level: PropTypes.number,
});

export const ProductFamiliesPropType = PropTypes.arrayOf(ProductFamilyPropType);

export const CampaignCreativePropType = PropTypes.shape({
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
});

export const PromoPropType = PropTypes.exact({
  campaign_uuid: PropTypes.string,
  name: PropTypes.string,
  redirection_url: PropTypes.string,
  creative_desktop: CampaignCreativePropType,
  creative_mobile: CampaignCreativePropType,
  start_date: PropTypes.number,
  end_date: PropTypes.number,
});

export const PromosPropType = PropTypes.arrayOf(PromoPropType);

export const InitialStatePropType = PropTypes.exact({
  platform: PropTypes.oneOf(Object.values(PLATFORMS)),
  basketCount: PropTypes.number,
  userId: PropTypes.number,
  isB2B: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  promos: PromosPropType,
  hasPromosBeenFetched: PropTypes.bool,
  products: ProductFamiliesPropType,
  hasProductsBeenFetched: PropTypes.bool,
  platformBaseUrl: PropTypes.string,
  abTests: PropTypes.shape({}),
  featureFlags: PropTypes.shape({}),
  baseUrls: PropTypes.shape({
    browserAPI: PropTypes.string,
  }),
});

export const IntlPropType = PropTypes.exact({
  messages: PropTypes.object,
  addLocaleData: PropTypes.func.isRequired,
  locale: PropTypes.oneOf(Object.values(LOCALES)),
});

export const HeaderWrapperPropType = PropTypes.exact({
  menu: PropTypes.string,
  product: PropTypes.string,
  promo: PropTypes.string,
  search: PropTypes.string,
  contact: PropTypes.string,
  account: PropTypes.string,
  list: PropTypes.string,
  basket: PropTypes.string,
  dropdown: PropTypes.string,
  mobileAccount: PropTypes.string,
  mobileBasket: PropTypes.string,
  mobileList: PropTypes.string,
  mobileMenu: PropTypes.string,
  familiesContainer: PropTypes.string,
});

export const SubHeaderPropType = PropTypes.exact({
  product: PropTypes.string,
  promo: PropTypes.string,
  search: PropTypes.string,
  contact: PropTypes.string,
  account: PropTypes.string,
  list: PropTypes.string,
  basket: PropTypes.string,
  familiesContainer: PropTypes.string,
});

export const MenuPropType = PropTypes.exact({
  mobileAccount: PropTypes.string,
  mobileBasket: PropTypes.string,
  mobileList: PropTypes.string,
  mobileMenu: PropTypes.string,
});
